<template>
    <div :id="modalId" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title">{{title}}</h2>
            <div class="uk-form-label uk-margin-medium-top uk-margin-medium-bottom">Are you sure you want to delete {{name}}?</div>

            <button class="uk-button uk-button-danger uk-modal-close" type="button" @click="deleteConfirmed">Delete</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button">Cancel</button>
        </div>
    </div>
</template>

<script>
    import EventBus from "../events";
    export default {
        props: {
            modalId:String,
            title:String,
            tableRef:String,
            nameField:{
                type:String,
                default:"name"
            },
            get:String,
            post:String
        },

        data(){
            return {
                id:null,
                name:""
            }
        },

        methods:{
            deleteConfirmed(){
                axios.get(this.ensureEndingSlash(this.post) + this.id).then((pack) => this.updateTable(pack));
            },
            updateTable(pack){
                if(this.tableRef){
                    this.$root.$refs[this.tableRef].startSearch();
                }
                if(pack.data.success){
                    EventBus.fireEvent("message", this.name + " deleted.");
                } else {
                    EventBus.fireEvent("error", this.name + " could not be deleted.");
                }
            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;
                this.name = data[this.nameField];
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            }
        }
    }
</script>

<style scoped>

</style>
